import { apiClient } from "./apiClient";

export type WhatsappConnectionStatus =
  | "disconnected"
  | "connecting"
  | "qr_pending"
  | "connected"
  | "reconnecting";

export interface WhatsappStatusResponse {
  status: WhatsappConnectionStatus;
  qrCode: string | null;
  connectedNumber: string | null;
  lastError: string | null;
}

export interface SendWhatsappTestMessageRequest {
  lojaId: number;
  numero: string;
  mensagem?: string;
}

export const whatsappService = {
  getStatus: (lojaId: number): Promise<WhatsappStatusResponse> =>
    apiClient.get<WhatsappStatusResponse>(
      `/whatsapp/status?lojaId=${encodeURIComponent(String(lojaId))}`
    ),

  connect: (lojaId: number): Promise<{ message: string }> =>
    apiClient.post<{ message: string }>("/whatsapp/connect", { lojaId }),

  disconnect: (lojaId: number): Promise<{ message: string }> =>
    apiClient.post<{ message: string }>("/whatsapp/disconnect", { lojaId }),

  sendTestMessage: (
    data: SendWhatsappTestMessageRequest
  ): Promise<{ message: string }> =>
    apiClient.post<{ message: string }>("/whatsapp/send-test", data),
};
